<template>
	<drawer>
		<h1>
			Заявки необходимо смотреть на вкладке "Помощь программиста"
			<a href="switchTab">Перейти</a>
		</h1>
	</drawer>
</template>
<script>
	import Drawer from "../common/Drawer.vue";
	export default {
		components: {
			Drawer
		},
		name: "InfoPage",
		data: () => ({

		})
	}
</script>
<style lang="css">
	.md-app-content {
		min-height: none;
	}
	.md-app {
		height: auto !important;
	}
	body {
		min-height: none;
	}
	html {
		height: auto;
	}
</style>


// WEBPACK FOOTER //
// Components/supportNew/infoPage.vue